import { Icon, LinkButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { getCompanyDomain } from '../company-details/utils';
import { SearchSocialMediaItem } from '../search-social-media-item';
import { DYNAMIC_SOCIAL_MEDIA } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import { type SearchSocialMediaProps as Props } from './types';

export const SearchSocialMedia = memo(
  ({ className, sx, socialLink, hideLinkOutIcon }: Props) => {
    const companyDomain = getCompanyDomain(socialLink);
    const hasDomain = useMemo(() => !!companyDomain, [companyDomain]);

    const linkColor = useMemo(
      () => (hasDomain ? 'grey.600' : 'grey.400'),
      [hasDomain]
    );

    return (
      <Styled.Wrapper
        className={classnames('SearchSocialMedia', className)}
        sx={sx}
      >
        {!hideLinkOutIcon && (
          <LinkButton
            variant="text"
            sx={SX.linkButton}
            href={companyDomain}
            disabled={hasDomain}
          >
            <Icon
              color={linkColor}
              size={18}
              name="link-out"
              sxx={SX.icon(hasDomain)}
            />
          </LinkButton>
        )}
        {DYNAMIC_SOCIAL_MEDIA.map((x) => (
          <SearchSocialMediaItem key={x.type} item={x} link={socialLink} />
        ))}
      </Styled.Wrapper>
    );
  }
);

SearchSocialMedia.displayName = 'SearchSocialMedia';
